var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobalLimit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32677_95243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0015 7.3125C9.86847 7.3125 7.31885 9.86375 7.31885 13C7.31885 16.1362 9.86847 18.6875 13.0015 18.6875C16.1345 18.6875 18.6825 16.1362 18.6825 13C18.6825 9.86375 16.1345 7.3125 13.0015 7.3125Z",
    fill: "#329EF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.83212 0 0 5.83212 0 13C0 20.1679 5.83212 26 13 26C20.1695 26 26 20.1679 26 13C26 5.83212 20.1695 0 13 0ZM22.8215 18.7297L19.3359 16.6384C18.6907 17.758 17.7596 18.6908 16.6416 19.3375L18.7297 22.8199C17.0462 23.8062 15.0898 24.375 13.0016 24.375V20.3125C11.6838 20.3125 10.4471 19.9599 9.37787 19.3456L7.37587 22.88C5.60462 21.8692 4.13237 20.3954 3.12 18.6257L6.65762 16.6221C6.04663 15.5529 5.694 14.3179 5.694 13H1.62662V13.0504C1.625 13.0341 1.625 13.0179 1.625 13C1.625 10.9249 2.18725 8.97975 3.16062 7.30437L6.69825 9.30962C7.33362 8.22738 8.23712 7.32225 9.31937 6.6885L7.36613 3.12487C9.0285 2.17262 10.9509 1.625 13 1.625H13.0016V5.6875C14.352 5.6875 15.6162 6.058 16.7017 6.69825L18.7411 3.18663C20.4604 4.19575 21.8904 5.642 22.88 7.37425L19.3456 9.37787C19.9566 10.4471 20.3076 11.6821 20.3076 13H24.375C24.375 14.0449 24.2336 15.0556 23.9688 16.016C23.7022 16.978 23.3155 17.888 22.8215 18.7297Z",
    fill: "#329EF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32677_95243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobalLimit);
export default ForwardRef;